import {EthereumClient, w3mConnectors, w3mProvider} from '@web3modal/ethereum'
import {Web3Modal} from '@web3modal/react'
import {configureChains, createConfig, WagmiConfig} from 'wagmi'
import {bscTestnet} from 'wagmi/chains'

import React from 'react';
import {
    BrowserRouter as Router
} from "react-router-dom";
import DepositForm from './components/DepositForm';
import {Web3Button} from '@web3modal/react'

const chains = [bscTestnet];
const projectId = '04b223b3a8a4f6ab1123d70dbc62bdab';

const {publicClient} = configureChains(chains, [w3mProvider({projectId})])
const wagmiConfig = createConfig({
    autoConnect: true,
    connectors: w3mConnectors({projectId, chains}),
    publicClient
})
const ethereumClient = new EthereumClient(wagmiConfig, chains)

function Application() {
    return (
        <>
            <WagmiConfig config={wagmiConfig}>
                <Router>
                    <table>
                        <tbody>
                        <tr>
                            <td>
                                <Web3Button/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <DepositForm/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Router>
            </WagmiConfig>
            <Web3Modal projectId={projectId} ethereumClient={ethereumClient}/>
        </>
    );
}

export default Application;
